import { Stack } from '@mui/material';
import {
  ContainedModal,
  ViewTreatmentConsultationItem,
} from 'components/molecules';
import { useTreatmentConsultation } from 'context';
import React from 'react';

export const ViewTreatmentConsultationModal: React.FC = () => {
  const { handleChangeSelectedConsultation, selectedTreatmentConsultation } =
    useTreatmentConsultation();

  const handleClose = () => {
    handleChangeSelectedConsultation(null);
  };

  const { consultType, anamnesis, diagnosis, treatment, orientation } =
    selectedTreatmentConsultation ?? {};

  return (
    <ContainedModal
      isOpen={Boolean(selectedTreatmentConsultation)}
      onClose={handleClose}
      title={
        consultType === 'teleconsultation'
          ? 'DETALHES DA TELECONSULTA'
          : 'DETALHES DA TELEORIENTAÇÃO'
      }
    >
      <Stack px={3} mt={4} spacing={4}>
        <ViewTreatmentConsultationItem title="Motivo/Anamnese">
          {anamnesis}
        </ViewTreatmentConsultationItem>

        <ViewTreatmentConsultationItem title="Diagnóstico">
          {diagnosis}
        </ViewTreatmentConsultationItem>

        <ViewTreatmentConsultationItem title="Tratamento">
          {treatment}
        </ViewTreatmentConsultationItem>

        <ViewTreatmentConsultationItem title="Orientações">
          {orientation}
        </ViewTreatmentConsultationItem>
      </Stack>
    </ContainedModal>
  );
};
